import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import {
    listVacTakenEnums,
} from "../../actions/vaccineAppointmentActions";
import { listUsers } from "../../actions/userActions";
import { listPatients, patientsDetails } from "../../actions/patientActions";
import { useNavigate } from "react-router-dom";
import showToast from "../../utils/toast";
import {
    useCreateVacApp,
    useInvalidateAppointments,
    useUpdateAppointment,
} from "../api/app";
import dayjs from "dayjs";

const AddAppVaccineModal = ({
    show,
    onClose,
    selectedTime = null,
    patientId,
    selectedDate = dayjs().format("YYYY-MM-DD"),
    edit,
    app,
    doctorId,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [doctor, setDoctor] = useState(app ? app.doctor._id : "");
    const [date, setDate] = useState(app ? app.date.slice(0, 10) : new Date());
    const [time, setTime] = useState(app ? app.time : "");
    const [status, setStatus] = useState();
    const [remarks, setRemarks] = useState("fever");
    const [selectedPatient, setSelectedPatient] = useState(
        app ? app.patient._id : ""
    );
    const [showModal, setShowModal] = useState(false);
    const [durationUnit, setDurationUnit] = useState(
        app ? app.duration : "5 min"
    );
    const [query, setQuery] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [showList, setShowList] = useState(false);

    const { userInfo } = useSelector((state) => state.userLogin);
    const { patient } = useSelector((state) => state.patientDetails);
    const { users } = useSelector((state) => state.userList);
    const { takes } = useSelector((state) => state.vaccineAppTaken);
    const { patients } = useSelector((state) => state.patientList);

    const createApp = useCreateVacApp();
    const updateApp = useUpdateAppointment();
    const invalidate = useInvalidateAppointments();

    useEffect(() => {
        setShowModal(show);
    }, [show]);

    useEffect(() => {
        setFilteredResults(patients);
    }, [patients]);

    useEffect(() => {
        if (userInfo) {
            dispatch(listUsers());
            if (!patientId) {
                dispatch(listPatients());
            }
            dispatch(listVacTakenEnums());
            if (patientId) {
                dispatch(patientsDetails(patientId));
            }
        }
    }, [dispatch, userInfo]);

    useEffect(() => {
        setDate(selectedDate);
        setTime(selectedTime);
    }, []);

    const handleInputChange = (e) => {
        const input = e.target.value;
        setQuery(input);
        console.log(input)
        dispatch(listPatients({ firstName: input }));
        setShowList(input.length > 0);
    };

    const handleItemClick = (item) => {
        setQuery(item.firstName + "-" + item.patientNumber);
        setShowList(false);
        setSelectedPatient(item._id);
    };

    const submitHandler = (e) => {
        e.preventDefault();
        const patient = patientId ? patientId : selectedPatient;
        const duration = `${durationUnit}`;

        const payload = {
            patient,
            doctor,
            date,
            time,
            status,
            remarks,
            duration,
        };

        if (edit) {
            updateApp.mutate(
                { _id: app._id, ...payload },
                {
                    onSuccess: () => {
                        showToast("Appointment updated successfully");
                        onClose();
                        invalidate();
                    },
                    onError: (err) => {
                        showToast(err?.response?.data?.message || err.message);
                    },
                }
            );
        } else {
            createApp.mutate(payload, {
                onSuccess: () => {
                    showToast("Appointment created successfully");
                    onClose();
                    invalidate();
                },
                onError: (err) => {
                    showToast(err?.response?.data?.message || err.message);
                },
            });
        }
    };

    return (
        <>
            {showModal && (
                <div
                    className="modal show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div
                            className="modal-content"
                            style={{
                                borderRadius: "15px",
                                border: "none",
                                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                            }}
                        >
                            <div
                                className="modal-header"
                                style={{
                                    background:
                                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    color: "white",
                                    borderRadius: "15px 15px 0 0",
                                    padding: "20px 25px",
                                    borderBottom: "none",
                                }}
                            >
                                <h5
                                    className="modal-title"
                                    style={{
                                        fontSize: "1.5rem",
                                        fontWeight: "600",
                                        margin: 0,
                                    }}
                                >
                                    <i
                                        className="fas fa-calendar-plus"
                                        style={{ marginRight: "10px" }}
                                    ></i>
                                    Add Appointment
                                </h5>
                                <button
                                    type="button"
                                    onClick={onClose}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: "white",
                                        fontSize: "1.5rem",
                                        cursor: "pointer",
                                        padding: "0",
                                        opacity: "0.8",
                                        transition: "opacity 0.2s",
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.target.style.opacity = "1")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.target.style.opacity = "0.8")
                                    }
                                >
                                    <i className="fa fa-times"></i>
                                </button>
                            </div>

                            <div
                                className="modal-body"
                                style={{ padding: "30px" }}
                            >
                                <button
                                    className="btn mb-4"
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                        color: "white",
                                        borderRadius: "25px",
                                        padding: "12px 25px",
                                        border: "none",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        boxShadow:
                                            "0 4px 15px rgba(102, 126, 234, 0.3)",
                                        transition: "all 0.3s ease",
                                    }}
                                    onClick={() =>
                                        navigate("/add-patient-details")
                                    }
                                    onMouseEnter={(e) => {
                                        e.target.style.transform =
                                            "translateY(-2px)";
                                        e.target.style.boxShadow =
                                            "0 6px 20px rgba(102, 126, 234, 0.4)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform =
                                            "translateY(0)";
                                        e.target.style.boxShadow =
                                            "0 4px 15px rgba(102, 126, 234, 0.3)";
                                    }}
                                >
                                    <i
                                        className="fas fa-plus"
                                        style={{ marginRight: "8px" }}
                                    ></i>
                                    Add Patient
                                </button>

                                <form onSubmit={submitHandler}>
                                    <div className="row g-4">
                                        {/* Patient and Doctor Row */}
                                        <div className="col-md-6">
                                            {patientId && (
                                                <div className="form-group">
                                                    <label
                                                        className="form-label"
                                                        style={{
                                                            fontWeight: "600",
                                                            color: "#333",
                                                            marginBottom: "8px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-user"
                                                            style={{
                                                                marginRight:
                                                                    "8px",
                                                                color: "#667eea",
                                                            }}
                                                        ></i>
                                                        Patient
                                                    </label>
                                                    <div
                                                        style={{
                                                            padding:
                                                                "12px 15px",
                                                            backgroundColor:
                                                                "#f8f9ff",
                                                            borderRadius:
                                                                "10px",
                                                            border: "2px solid #e9ecef",
                                                            fontWeight: "500",
                                                            color: "#495057",
                                                        }}
                                                    >
                                                        {`${patient?.firstName}${" "}${patient?.lastName}-${patient?.patientNumber}`}
                                                    </div>
                                                </div>
                                            )}

                                            {!patientId && (
                                                <div className="form-group">
                                                    <label
                                                        className="form-label"
                                                        style={{
                                                            fontWeight: "600",
                                                            color: "#333",
                                                            marginBottom: "8px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-user"
                                                            style={{
                                                                marginRight:
                                                                    "8px",
                                                                color: "#667eea",
                                                            }}
                                                        ></i>
                                                        Patient
                                                    </label>
                                                    <div
                                                        style={{
                                                            position:
                                                                "relative",
                                                        }}
                                                    >
                                                        <input
                                                            type="text"
                                                            placeholder="Search patient..."
                                                            value={query}
                                                            onChange={
                                                                handleInputChange
                                                            }
                                                            style={{
                                                                width: "100%",
                                                                padding:
                                                                    "12px 15px",
                                                                fontSize:
                                                                    "14px",
                                                                border: "2px solid #e9ecef",
                                                                borderRadius:
                                                                    "10px",
                                                                transition:
                                                                    "all 0.3s ease",
                                                                backgroundColor:
                                                                    "#fff",
                                                            }}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor =
                                                                    "#667eea";
                                                                e.target.style.boxShadow =
                                                                    "0 0 0 0.2rem rgba(102, 126, 234, 0.25)";
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor =
                                                                    "#e9ecef";
                                                                e.target.style.boxShadow =
                                                                    "none";
                                                            }}
                                                        />
                                                        {showList && (
                                                            <ul
                                                                style={{
                                                                    listStyleType:
                                                                        "none",
                                                                    padding:
                                                                        "0",
                                                                    margin: "5px 0 0 0",
                                                                    border: "2px solid #e9ecef",
                                                                    borderRadius:
                                                                        "10px",
                                                                    maxHeight:
                                                                        "200px",
                                                                    overflowY:
                                                                        "auto",
                                                                    backgroundColor:
                                                                        "#fff",
                                                                    position:
                                                                        "absolute",
                                                                    width: "100%",
                                                                    zIndex: 1000,
                                                                    boxShadow:
                                                                        "0 4px 12px rgba(0,0,0,0.1)",
                                                                }}
                                                            >
                                                                {filteredResults &&
                                                                filteredResults
                                                                    .patient
                                                                    .length >
                                                                    0 ? (
                                                                    filteredResults.patient.map(
                                                                        (
                                                                            item
                                                                        ) => (
                                                                            <li
                                                                                key={
                                                                                    item._id
                                                                                }
                                                                                onClick={() =>
                                                                                    handleItemClick(
                                                                                        item
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    padding:
                                                                                        "12px 15px",
                                                                                    cursor: "pointer",
                                                                                    transition:
                                                                                        "background-color 0.2s",
                                                                                    borderBottom:
                                                                                        "1px solid #f1f3f4",
                                                                                }}
                                                                                onMouseEnter={(
                                                                                    e
                                                                                ) =>
                                                                                    (e.target.style.backgroundColor =
                                                                                        "#f8f9ff")
                                                                                }
                                                                                onMouseLeave={(
                                                                                    e
                                                                                ) =>
                                                                                    (e.target.style.backgroundColor =
                                                                                        "#fff")
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className="fas fa-user-circle"
                                                                                    style={{
                                                                                        marginRight:
                                                                                            "8px",
                                                                                        color: "#667eea",
                                                                                    }}
                                                                                ></i>
                                                                                {item.firstName + " " + item?.lastName +
                                                                                    "-" +
                                                                                    item.patientNumber}
                                                                            </li>
                                                                        )
                                                                    )
                                                                ) : (
                                                                    <li
                                                                        style={{
                                                                            padding:
                                                                                "12px 15px",
                                                                            color: "#6c757d",
                                                                            fontStyle:
                                                                                "italic",
                                                                            textAlign:
                                                                                "center",
                                                                        }}
                                                                    >
                                                                        <i
                                                                            className="fas fa-search"
                                                                            style={{
                                                                                marginRight:
                                                                                    "8px",
                                                                            }}
                                                                        ></i>
                                                                        No
                                                                        matching
                                                                        results
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#333",
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <i
                                                        className="fas fa-user-md"
                                                        style={{
                                                            marginRight: "8px",
                                                            color: "#667eea",
                                                        }}
                                                    ></i>
                                                    Doctor
                                                </label>
                                                {userInfo.role == 1 ? (
                                                    <div
                                                        style={{
                                                            padding:
                                                                "12px 15px",
                                                            backgroundColor:
                                                                "#f8f9ff",
                                                            borderRadius:
                                                                "10px",
                                                            border: "2px solid #e9ecef",
                                                            fontWeight: "500",
                                                            color: "#495057",
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-stethoscope"
                                                            style={{
                                                                marginRight:
                                                                    "8px",
                                                                color: "#667eea",
                                                            }}
                                                        ></i>
                                                        Dr. {userInfo.name}
                                                    </div>
                                                ) : (
                                                    <select
                                                        value={doctor}
                                                        onChange={(e) =>
                                                            setDoctor(
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            padding:
                                                                "12px 15px",
                                                            fontSize: "14px",
                                                            border: "2px solid #e9ecef",
                                                            borderRadius:
                                                                "10px",
                                                            transition:
                                                                "all 0.3s ease",
                                                            backgroundColor:
                                                                "#fff",
                                                        }}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor =
                                                                "#667eea";
                                                            e.target.style.boxShadow =
                                                                "0 0 0 0.2rem rgba(102, 126, 234, 0.25)";
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor =
                                                                "#e9ecef";
                                                            e.target.style.boxShadow =
                                                                "none";
                                                        }}
                                                    >
                                                        <option>
                                                            Select Doctor
                                                        </option>
                                                        {users &&
                                                            users
                                                                .filter(
                                                                    (user) =>
                                                                        user.role ===
                                                                        1
                                                                )
                                                                .map((c) => (
                                                                    <option
                                                                        key={
                                                                            c._id
                                                                        }
                                                                        value={
                                                                            c._id
                                                                        }
                                                                    >
                                                                        Dr.{" "}
                                                                        {c.name}
                                                                    </option>
                                                                ))}
                                                    </select>
                                                )}
                                            </div>
                                        </div>

                                        {/* Time and Date Row */}
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#333",
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <i
                                                        className="fas fa-clock"
                                                        style={{
                                                            marginRight: "8px",
                                                            color: "#667eea",
                                                        }}
                                                    ></i>
                                                    Time
                                                </label>
                                                <input
                                                    type="time"
                                                    value={time}
                                                    onChange={(e) =>
                                                        setTime(e.target.value)
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        padding: "12px 15px",
                                                        fontSize: "14px",
                                                        border: "2px solid #e9ecef",
                                                        borderRadius: "10px",
                                                        transition:
                                                            "all 0.3s ease",
                                                        backgroundColor: "#fff",
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor =
                                                            "#667eea";
                                                        e.target.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(102, 126, 234, 0.25)";
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor =
                                                            "#e9ecef";
                                                        e.target.style.boxShadow =
                                                            "none";
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#333",
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <i
                                                        className="fas fa-calendar-alt"
                                                        style={{
                                                            marginRight: "8px",
                                                            color: "#667eea",
                                                        }}
                                                    ></i>
                                                    Date
                                                </label>
                                                <input
                                                    type="date"
                                                    value={date}
                                                    onChange={(e) =>
                                                        setDate(e.target.value)
                                                    }
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        padding: "12px 15px",
                                                        fontSize: "14px",
                                                        border: "2px solid #e9ecef",
                                                        borderRadius: "10px",
                                                        transition:
                                                            "all 0.3s ease",
                                                        backgroundColor: "#fff",
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor =
                                                            "#667eea";
                                                        e.target.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(102, 126, 234, 0.25)";
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor =
                                                            "#e9ecef";
                                                        e.target.style.boxShadow =
                                                            "none";
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Duration */}
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#333",
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <i
                                                        className="fas fa-hourglass-half"
                                                        style={{
                                                            marginRight: "8px",
                                                            color: "#667eea",
                                                        }}
                                                    ></i>
                                                    Duration
                                                </label>
                                                <select
                                                    value={durationUnit}
                                                    onChange={(e) =>
                                                        setDurationUnit(
                                                            e.target.value
                                                        )
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "200px",
                                                        padding: "12px 15px",
                                                        fontSize: "14px",
                                                        border: "2px solid #e9ecef",
                                                        borderRadius: "10px",
                                                        transition:
                                                            "all 0.3s ease",
                                                        backgroundColor: "#fff",
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor =
                                                            "#667eea";
                                                        e.target.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(102, 126, 234, 0.25)";
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor =
                                                            "#e9ecef";
                                                        e.target.style.boxShadow =
                                                            "none";
                                                    }}
                                                >
                                                    <option value="5 min">
                                                        5 min
                                                    </option>
                                                    <option value="10 min">
                                                        10 min
                                                    </option>
                                                    <option value="15 min">
                                                        15 min
                                                    </option>
                                                    <option value="30 min">
                                                        30 min
                                                    </option>
                                                    <option value="45 min">
                                                        45 min
                                                    </option>
                                                    <option value="1 hr">
                                                        1 hr
                                                    </option>
                                                    <option value="1 hr 30 min">
                                                        1 hr 30 min
                                                    </option>
                                                    <option value="1 hr 45 min">
                                                        1 hr 45 min
                                                    </option>
                                                    <option value="2 hr">
                                                        2 hr
                                                    </option>
                                                    <option value="2 hr 30 min">
                                                        2 hr 30 min
                                                    </option>
                                                    <option value="2 hr 45 min">
                                                        2 hr 45 min
                                                    </option>
                                                    <option value="3 hr">
                                                        3 hr
                                                    </option>
                                                    <option value="3 hr 30 min">
                                                        3 hr 30 min
                                                    </option>
                                                    <option value="3 hr 45 min">
                                                        3 hr 45 min
                                                    </option>
                                                    <option value="4 hr">
                                                        4 hr
                                                    </option>
                                                    <option value="4 hr 30 min">
                                                        4 hr 30 min
                                                    </option>
                                                    <option value="4 hr 45 min">
                                                        4 hr 45 min
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end mt-4">
                                        <button
                                            type="submit"
                                            style={{
                                                background:
                                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                color: "white",
                                                padding: "12px 30px",
                                                border: "none",
                                                borderRadius: "25px",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                boxShadow:
                                                    "0 4px 15px rgba(102, 126, 234, 0.3)",
                                                transition: "all 0.3s ease",
                                                minWidth: "120px",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform =
                                                    "translateY(-2px)";
                                                e.target.style.boxShadow =
                                                    "0 6px 20px rgba(102, 126, 234, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform =
                                                    "translateY(0)";
                                                e.target.style.boxShadow =
                                                    "0 4px 15px rgba(102, 126, 234, 0.3)";
                                            }}
                                        >
                                            <i
                                                className={
                                                    edit
                                                        ? "fas fa-save"
                                                        : "fas fa-plus"
                                                }
                                                style={{ marginRight: "8px" }}
                                            ></i>
                                            {edit ? "Update" : "Save"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddAppVaccineModal;
